import React from "react";
import { Mail, MessageCircle } from "lucide-react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import PageContainer from "../components/layout/PageContainer";
import SubscriptionPlanGrid from "../components/subscription/SubscriptionPlanGrid";
import {
    getSubscriptionPlanOptions,
    SUBSCRIPTION_PLAN_OPTIONS,
} from "../components/subscription/subscriptionPlans";
import { getTierName } from "../utils/subscription";

const EMAIL_URL =
    "https://mail.google.com/mail/?view=cm&fs=1&to=connect@gennxt.co&su=Subscription%20Request";
const WHATSAPP_CONTACT_URL = "https://bit.ly/gennxt-whatsapp";

const ManageSubscription = () => {
    const location = useLocation();
    const { credits, isAuthenticated, user } = useSelector(
        (state) => state.auth,
    );
    const currentPlanName = isAuthenticated
        ? getTierName(credits, user?.plan || "starter")
        : null;
    const shouldShowPlanSelection =
        location.state?.fromProfileDropdown === true;
    const visiblePlans = shouldShowPlanSelection
        ? getSubscriptionPlanOptions(currentPlanName)
        : SUBSCRIPTION_PLAN_OPTIONS;

    return (
        <main className="min-h-screen bg-[#F8F8FE]">
            <PageContainer className="py-5 sm:py-8">
                <header className="mx-auto max-w-3xl text-center">
                    <h1 className="text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
                        {isAuthenticated ? "Manage Subscription" : "Subscription"}
                    </h1>
                    <p className="mt-3 text-sm leading-7 text-slate-600 sm:text-base">
                        Review your plan limits and contact us to upgrade,
                        downgrade, or discuss pricing.
                    </p>
                </header>

                <div className="mt-8">
                    <SubscriptionPlanGrid
                        plans={visiblePlans}
                        currentPlanName={currentPlanName}
                    />
                </div>

                <section className="mt-8 rounded-3xl border border-indigo-100 p-6 text-center shadow-sm sm:p-8">
                    <div className="mx-auto max-w-2xl">
                        <h2 className="text-2xl font-bold tracking-tight text-slate-950">
                            Need to change your subscription?
                        </h2>
                        <p className="mt-3 text-sm leading-7 text-slate-600 sm:text-base">
                            For pricing, upgrades, downgrades, or custom limits,
                            contact our team.
                        </p>
                        <div className="mt-6 flex flex-col justify-center gap-3 sm:flex-row">
                            <a
                                href={EMAIL_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center gap-2 rounded-2xl border border-indigo-100 bg-indigo-50 px-5 py-3 text-sm font-semibold text-indigo-700 shadow-sm transition hover:bg-indigo-100"
                            >
                                <Mail size={17} aria-hidden="true" />
                                Email Us
                            </a>
                            <a
                                href={WHATSAPP_CONTACT_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center gap-2 rounded-2xl  bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700"
                            >
                                <MessageCircle size={17} aria-hidden="true" />
                                Chat on WhatsApp
                            </a>
                        </div>
                    </div>
                </section>
            </PageContainer>
        </main>
    );
};

export default ManageSubscription;
